//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,toCopy} from '@/utils/util.js'
import {uploadFile} from '@/utils/auth'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';
import homeTip from '@/components/homeTip'

export default {
  name: "qualityOrderDetail",
  components: {
    footerNav,
    homeTip
  },
  data() {
    return {
      loading1:false,
      loading2:false,
      loading3:false,
      value:'',
      toCopy,
      reasonList:[
      ],
      columns:[{text:'是',value:1},{text:'否',value:0}],
      fileList:[],
      showPicker:false,
      basicForm: {
        qualityOrderSn: '',
        sendOrderSn: '',
        purchaseOrderSn: '',
        supplierName: '',
        channelStr: '',
        qualityOrderTypeName: '',
        qualityOrderDetailList: [],
        qualityOrderResultDetailList: [],
        attachedFile: [],
        isStockIn:'',
        confirmFileStr:'',
        confirmFile:'',
        remark:'',
        qualityResult:'',
        qualityOrderStatusName:'',
        billDate:'',
        externalOrder:'',
        needAduit:'',
        spuCode:'',
        sendTotalGoodsNum:'',
        crtTime:'',
        colorValue:'',
        qualityResultId:''
      },
      qualityOrderId:'',
      qualityResultId:'',
      isSend:false,
      dataList:{},
      canSubmit:true
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.data) {
      this.dataList = JSON.parse(this.$route.query.data)
    }
    if (this.$route.query.qualityOrderId) {
      this.qualityOrderId = this.$route.query.qualityOrderId
      this.qualityResultId = this.$route.query.qualityResultId
    }
    this.getSpecList()
  },
  methods: {
    hasBtn(id){
      return this.$store.state.btnList.indexOf(id)!=-1
    },
    getSpecList() {
      var queryParams = {
        qualityOrderColorList:[this.dataList]
      };
      if (this.$route.query.data) {
        queryParams.qualityOrderColorList = [this.dataList]
      }else{
        queryParams.qualityOrderId = this.qualityOrderId
        queryParams.qualityResultId = this.qualityResultId
        queryParams.qualityOrderColorList = []
      }
      axiosApi.queryQualityOrderByColor(queryParams).then(response => {
        var data = response.content;
        if(data.qualityOrderDetailList){
          data.qualityOrderDetailList.forEach((item)=>{item.isEdit = true})
        }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if(this.basicForm.firstDeptName){
          channelStr+=this.basicForm.firstDeptName
        }
        if(this.basicForm.secondDeptName){
          channelStr+='/'+this.basicForm.secondDeptName
        }
        if(data.attachedFile&&data.attachedFile.length>0){
          data.attachedFile.forEach((item)=>{
            this.fileList.push({url:item})
          })
        }
        if(this.basicForm.qualityResult===0){
          this.value='否'
        }
        if(this.basicForm.qualityResult===1){
          this.value='是'
        }
        this.$set(this.basicForm, 'channelStr', channelStr)
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    toMore(){
      this.$router.push({name:'qualityOrderDetailMore'})
    },
    toBase(){
      var query = {}
      if (this.$route.query.data) {
        query.data = JSON.stringify(this.dataList)
      }
      if (this.$route.query.qualityOrderId) {
        query.qualityOrderId = this.$route.query.qualityOrderId
        query.qualityResultId = this.$route.query.qualityResultId
      }
      this.$router.push({name:'someQualityDetailAll',query:query})
    },
    toAddReason(){
      this.$router.push({name:'addReason',type:2})
    },
    afterRead(file) {
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration:0
      });
      this.canSubmit = false
      // console.log(file)
      // console.log(this.fileList)
      if(Array.isArray(file)){
        for (var i in file){
          uploadFile(file[i].file, 'file', url => {
            // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
            this.basicForm.attachedFile.push(url)
            if(i==(file.length-1)){
              this.canSubmit = true
              Toast.clear()
            }
          });
        }
      }else{
        uploadFile(file.file, 'file', url => {
          // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
          this.basicForm.attachedFile.push(url)
          this.canSubmit = true
          Toast.clear()
        });
      }
    },
    delImg (file, detail) {
      return new Promise((resolve, reject) => {
        this.basicForm.attachedFile.splice(detail.index, 1)
        resolve();
      });
    },
    //
    save(type,key) {
      if(!this.canSubmit) return
      if(this[key])return
      if(type==1&&this.value==''){
        Toast.fail('请选择是否合格');
      }
      this[key] = true
      // if (!this.checkNum()) {
      //   this.$message.error('添加不合格原因的件数与质检结果的不合格件数不对应');
      //   return
      // }
      // for (var i = 0; i < this.basicForm.qualityOrderDetailList.length; i++) {
      //   var num = 0
      //   if (this.basicForm.qualityOrderDetailList[i].goodNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].goodNum)
      //   }
      //   if (this.basicForm.qualityOrderDetailList[i].badNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].badNum)
      //   }
      //   if (num > parseInt(this.basicForm.qualityOrderDetailList[i].sendGoodsNum)) {
      //     this.$message.error('合格数加不合格数不能大于抽检数');
      //     return
      //   }
      // }
      var queryParams = {
        ...this.basicForm,
        qualityOrderStatus: type,
      }
      axiosApi.submitQualityOrder(queryParams).then(response => {
        Toast.success('操作成功');
        this[key] = false
        if (type != 0) {
          this.$router.back(-1)
        }
      }).catch(error => {
        this[key] = false
      })
    },
    onConfirm(value) {
      this.value = value.text;
      this.basicForm.qualityResult = value.value;
      this.showPicker = false;
    },
    open(){
      if(this.basicForm.qualityOrderStatus!=0)return
      this.showPicker = true
    },
    save1() {
      if(!this.canSubmit) return
      if(this.loading2)return
      this.loading2 = true
      // if (!this.checkNum()) {
      //   this.$message.error('添加不合格原因的件数与质检结果的不合格件数不对应');
      //   return
      // }
      // for (var i = 0; i < this.basicForm.qualityOrderDetailList.length; i++) {
      //   var num = 0
      //   if (this.basicForm.qualityOrderDetailList[i].goodNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].goodNum)
      //   }
      //   if (this.basicForm.qualityOrderDetailList[i].badNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].badNum)
      //   }
      //   if (num > parseInt(this.basicForm.qualityOrderDetailList[i].sendGoodsNum)) {
      //     this.$message.error('合格数加不合格数不能大于抽检数');
      //     return
      //   }
      // }
      var queryParams = {
        ...this.basicForm,
      }
      axiosApi.updateQualityOrder(queryParams).then(response => {
        Toast.success('操作成功');
        this.loading2 = false
        this.$router.back(-1)
      }).catch(error => {
        this.loading2 = false
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/detail.vue